<template>
  <div>
    <img :src="getImgUrl()" class="saturate-low"
      :class="{ 'report-grow': props.growReport }"
      :style="getStyle()"   
    > 
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'

  const props = defineProps({ 
    size: String,
    type: String,
    growReport: Boolean,
    duration: Number,
  });

  const sizeType = {big: {height: '80px', width: '50px'},
                    smaller:{height: '10px', width: '15px'},
                    small:{height: '30px', width: '20px'},
                    small1:{height: '50px', width: '16px'},
                    small2:{height: '50px', width: '30px'},
                    smallWide: {height: '33px', width: '33px'},
                    smallWide2: {height: '30px', width: '29px'},
                    medium:{height: '55px', width: '35px'},
                    medium2:{height: '65px', width: '50px'},
                    medium3: {height: '50px', width: '50px'},
                    long: {height: '80px', width: '26px'},
                    wide: {height: '65px', width: '85px'},
                    wider: {height: '80px', width: '100px'},
                    widest: {height: '100px', width: '150px'},
                    bigger: {height: '100px', width: '70px'},
                    large: {height: '140px', width: '140px'},
                    large2: {height: '130px', width: '120px'},
                    large3: {height: '130px', width: '75px'},
                    large4: {height: '120px', width: '80px'},
                    large5: {height: '110px', width: '100px'},
                  }

  const type = {indusPhysician:require('@/assets/01_IndustrialPhysician.png'), 
                indusPhysicianSideways:require('@/assets/01_IndustrialPhysicianSideways.png'), 
                hlthPromoter: require('@/assets/03_HealthPromoter.png'),
                hlthSftyPromoter: require('@/assets/04_Health&SafetyPromoter.png'),
                hlthOfficer: require('@/assets/05_HealthOfficer.png'),
                hlthOfficerSideways: require('@/assets/05_HealthOfficerSideways.png'),
                sftyOfficer: require('@/assets/06_SafetyOfficer.png'),
                emplyRepresentative : require( '@/assets/07_EmployeeRepresentative.png'),
                hlthSftyManager: require( '@/assets/09_Health&SafetyManager.png'),
                wrkplcManager: require( '@/assets/10_WorkPlaceManager.png'),
                lso : require( '@/assets/12_LaborStandardsOffice.png'),
                hlthClinic : require( '@/assets/01_Clinic.png'),
                safeBox: require( '@/assets/SafeBox.png'),
                report: require( '@/assets/Report.png'),
                report2: require( '@/assets/Report2.png'),
                report3: require( '@/assets/Report3.png'),
                confidentialreport: require( '@/assets/ConfidentialReport.png'),
                regEmployee: require( '@/assets/15_RegularEmployee.png'),
                regEmployeeSideways: require( '@/assets/15_RegularEmployeeSideways.png'),
                workplace: require( '@/assets/17_Workplace.png'),
                memberActive: require( '@/assets/Member-active.png'),
                memberInactive: require( '@/assets/Member-inactive.png'),
                physician: require( '@/assets/Physician.png'),
                laptop: require( '@/assets/Laptop.png'),
              }

  function getImgUrl() {
    if (props.type) {
      return  type[props.type]
    }
  }
  function getImgSize () {
    let res = {}
    if(props.size) {
      res = {...sizeType[props.size]}
    }
    return res
  }
  function getStyle () {
    const styleObj = getImgSize();
    if (props.growReport && props.duration) {
      styleObj['animation-duration'] = props.duration + 's';
    }
    return styleObj;
  }
</script>

<style scoped>
.report-grow {
  animation-name: reportGrow;
  scale: 0;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}
@keyframes reportGrow {
  from {scale: 0.3;}
  to {scale: 1;}
}
.saturate-low {
  filter: invert(12%) sepia(13%) brightness(110%) contrast(90%);
}
</style>
